export default {
  data() {
    return {
      searchSchema: [
        {
          label: '国家名称',
          type: 'input',
          itemName: 'countryName',
          allowClear: true,
        },
        {
          label: '年份',
          itemName: 'year',
          type: 'yearPicker',
          allowClear: true,
        },
        {
          label: '国家评级',
          type: 'input',
          itemName: 'rate',
          allowClear: true,
        },
      ],
      searchForm: {
        countryName: '',
        year: '',
        rate: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '国家名称',
          width: 120,
          dataIndex: 'countryName',
        },
        {
          title: '年份',
          width: 140,
          dataIndex: 'year',
        },
        {
          title: '国家评级',
          width: 220,
          dataIndex: 'rate',
        },
        {
          title: '编辑人名称',
          width: 180,
          dataIndex: 'operator',
        },
        {
          title: '操作',
          width: 140,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
